const MODULE_NAME = 'fulcrum/container/Project/Hierarchies'

const OPEN_DIALOG = MODULE_NAME + '/OPEN_DIALOG'
const CLOSE_DIALOG = MODULE_NAME + '/CLOSE_DIALOG'
const UPDATE_HIERARCHY_TYPE = MODULE_NAME + '/UPDATE_HIERARCHY_TYPE'

const ADD_PROJECT = MODULE_NAME + '/ADD_PROJECT'
const REMOVE_PROJECT = MODULE_NAME + '/REMOVE_PROJECT'
const UPDATE_PROJECTS = MODULE_NAME + '/UPDATE_PROJECTS'
const UPDATE_COMMENT = MODULE_NAME + '/UPDATE_COMMENT'

const FETCH_HIERARCHIES = MODULE_NAME + '/FETCH_HIERARCHIES'
const FETCH_HIERARCHIES_START = MODULE_NAME + '/FETCH_HIERARCHIES_START'
const FETCH_HIERARCHIES_SUCCESS = MODULE_NAME + '/FETCH_HIERARCHIES_SUCCESS'
const FETCH_HIERARCHIES_ERROR = MODULE_NAME + '/FETCH_HIERARCHIES_ERROR'

const FETCH_PROJECTS_SEARCH = MODULE_NAME + '/FETCH_PROJECTS_SEARCH'
const FETCH_PROJECTS_SEARCH_START = MODULE_NAME + '/FETCH_PROJECTS_SEARCH_START'
const FETCH_PROJECTS_SEARCH_SUCCESS = MODULE_NAME + '/FETCH_PROJECTS_SEARCH_SUCCESS'
const FETCH_PROJECTS_SEARCH_ERROR = MODULE_NAME + '/FETCH_PROJECTS_SEARCH_ERROR'
const UPDATE_PROJECTS_SEARCH = MODULE_NAME + '/UPDATE_PROJECTS_SEARCH'

const POST_HIERARCHIES = MODULE_NAME + '/POST_HIERARCHIES'
const POST_HIERARCHIES_START = MODULE_NAME + '/POST_HIERARCHIES_START'
const POST_HIERARCHIES_SUCCESS = MODULE_NAME + '/POST_HIERARCHIES_SUCCESS'
const POST_HIERARCHIES_ERROR = MODULE_NAME + '/POST_HIERARCHIES_ERROR'

const UPDATE_COMMENTS = MODULE_NAME + '/UPDATE_COMMENTS'

const HIERARCHIES_OPTIONS = 
    [{
        value: 'primary', 
        label:'Primary (Default)'
    }, {
        value: 'leveraged', 
        label: 'Leveraged'
    }]


export {
    OPEN_DIALOG,
    CLOSE_DIALOG,
    UPDATE_HIERARCHY_TYPE,
    HIERARCHIES_OPTIONS,
    ADD_PROJECT,
    REMOVE_PROJECT,
    UPDATE_PROJECTS,
    UPDATE_COMMENT,
    FETCH_HIERARCHIES,
    FETCH_HIERARCHIES_START,
    FETCH_HIERARCHIES_SUCCESS,
    FETCH_HIERARCHIES_ERROR,
    FETCH_PROJECTS_SEARCH,
    FETCH_PROJECTS_SEARCH_START,
    FETCH_PROJECTS_SEARCH_SUCCESS,
    FETCH_PROJECTS_SEARCH_ERROR,
    UPDATE_PROJECTS_SEARCH,
    POST_HIERARCHIES,
    POST_HIERARCHIES_START,
    POST_HIERARCHIES_SUCCESS,
    POST_HIERARCHIES_ERROR,
    UPDATE_COMMENTS
}

